import React from 'react';
import { CommentsDrawer } from './CommentsDrawer';
import { ConditionsActions } from './ConditionsActions';
import { ConditionSection } from './ConditionSection';
import { ConditionsSummary } from './ConditionsSummary';
import { ConditionsToolbar } from './ConditionsToolbar';
import { LinkDocumentsDialog } from './LinkDocumentsDialog';
import { useConditions } from '../../hooks/useConditions';
export function ConditionsPanel() {
  const state = useConditions();
  const sectionHandlers = {
    selectedIds: state.selectedIds,
    onToggleSelect: state.toggleSelect,
    onToggleSelectAll: state.toggleSelectAll,
    onUpdate: state.updateCondition,
    onComments: state.openComments,
    onUpload: state.uploadDocument,
    onLinkDocuments: state.openLinkDocuments
  };
  return <article className="rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-150" data-mp="8je2elj6fxc5">
      <header className="flex flex-wrap items-center justify-between gap-3 px-5 pt-4" data-id="element-151" data-mp="dhxpwqdf5h6m">
        <div className="flex items-center gap-3" data-id="element-152" data-mp="djsb85slrbb8">
          <img src="https://cdn.magicpatterns.com/uploads/rFKdeWtVWUw6dZPg5dUKok/image.png" alt="Mortgage Depot" className="h-11 w-auto" data-id="element-153" data-mp="2m28fs6wa4lk1" />
          <span className="h-9 w-px bg-slate-200" aria-hidden="true" data-id="element-154" data-mp="2calxjqlixm7s" />
          <div data-id="element-155" data-mp="289saezfwobfy">
            <h2 className="text-base font-semibold text-charcoal" data-id="element-156" data-mp="28absqh9gx1ui">Conditions</h2>
            <p className="text-xs text-slate-500" data-id="element-157" data-mp="3502loc242gy7">Loan #2026-10482 · Johnson, Michael &amp; Sarah</p>
          </div>
        </div>
        <ConditionsActions selectedCount={state.selectedIds.size} data-id="element-158" data-mp="300pzzumz7fx7" />
      </header>

      <div className="mt-4 border-t border-slate-200" data-id="element-159" data-mp="2vz4gvrjum5ek" />

      <ConditionsSummary conditions={state.filteredConditions} attentionFilter={state.attentionFilter} onAttentionFilterChange={state.setAttentionFilter} statusFilter={state.statusFilter} onStatusFilterChange={state.setStatusFilter} data-id="element-160" data-mp="2vxjmq31g4oh8" />

      <ConditionsToolbar searchQuery={state.searchQuery} onSearchChange={state.setSearchQuery} assigneeFilter={state.assigneeFilter} onAssigneeChange={state.setAssigneeFilter} titleNotesAdded={state.titleNotesAdded} onTitleNotesChange={state.setTitleNotesAdded} selectedCount={state.selectedIds.size} data-id="element-161" data-mp="1fkbmof38diq2" />

      <div data-id="element-162" data-mp="1c2nu2iadqigh">
        {state.outstandingGroups.map(group => <ConditionSection key={group.id} title={group.label} conditions={group.conditions} emptyMessage={`No outstanding ${group.label.toLowerCase()} conditions.`} {...sectionHandlers} data-id="element-163" data-mp="1c51oqq15dsni" />)}
        <ConditionSection title="Cleared" conditions={state.cleared} emptyMessage="No cleared conditions yet." defaultOpen={false} showCategory accent="steel" {...sectionHandlers} data-id="element-164" data-mp="of7d2bskea4u" />
      </div>

      <CommentsDrawer condition={state.commentCondition} onClose={state.closeComments} onSubmit={state.addComment} data-id="element-165" data-mp="kcaom4gcfjsz" />
      <LinkDocumentsDialog condition={state.linkCondition} onClose={state.closeLinkDocuments} onLink={state.linkDocuments} data-id="element-166" data-mp="r0qg7mhmv09" />
    </article>;
}